<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 14:27:03
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 11:16:36
-->
<template>
  <div class="about">
    <div ref="about" class="about-bj">
      <div class="ui-title textc">{{$t('about.about.title')}}</div>
      <div class="ui-des textc">{{$t('about.about.des')}}</div>
      <!-- <div class="about-bj-list" :class="{textj: language != 'en'}"> -->
      <div class="about-bj-list textj">
        <template v-if="language == 'en'">
          <p class="p-b-30" v-for="(item, index) in about" :key="index" v-html="item"></p>
        </template>
        <template v-else>
          <p class="p-b-30" v-for="(item, index) in about" :key="index">
            <span v-for="($item, $index) in item" :key="index + '_' +$index" :class="aboutActive >= $index + getNum('about', index) ? 'on' : ''" v-html="$item"></span>
          </p>
        </template>
      </div>
      <div class="flex justify_content_center"><img class="about-bj-img" :src="require('@/assets/images/about/1.png')" alt="" srcset=""></div>
    </div>
    <div ref="culture" class="about-bj about-culture">
      <div class="about-culture-title">{{$t('about.culture.title')}}</div>
      <div class="about-culture-box">
        <div :class="['about-culture-list', cultureStatus ? 'show' : '']" v-for="(item, index) in $t('about.culture.list')" :key="index">
          <div class="about-culture-list-title flex align_items_center"><img :src="require(`@/assets/images/about/2-${index + 1}.png`)" alt="" srcset=""><span class="p-l-20">{{item.title}}</span></div>
          <div class="about-culture-list-des">{{item.des}}</div>
        </div>
      </div>
      <div class="flex justify_content_center"><img class="about-bj-img about-culture-img" :src="require('@/assets/images/about/2.png')" alt="" srcset=""></div>
    </div>
    <div ref="international" class="about-bj about-international">
      <div class="about-international-title textc">{{$t('about.international.title')}}</div>
      <!-- <div class="about-bj-list" :class="{textj: language != 'en'}"> -->
      <div class="about-bj-list textj">
        <template v-if="language == 'en'">
          <p class="p-b-10" v-for="(item, index) in international" :key="index" v-html="item"></p>
        </template>
        <template v-else>
          <p class="p-b-10" v-for="(item, index) in international" :key="index">
            <span v-for="($item, $index) in item" :key="index + '_' +$index" :class="internationalActive >= $index + getNum('international', index) ? 'on' : ''" v-html="$item"></span>
          </p>
        </template>
      </div>
      <div class="flex justify_content_center"><img class="about-bj-img about-international-img" :src="require('@/assets/images/about/3.png')" alt="" srcset=""></div>
    </div>
    <div ref="history" class="about-history flex flex_col justify_content_center align_items_center">
      <div class="about-history-title textc">{{$t('about.history.title')}}</div>
      <div class="about-history-bj">
        <div class="about-history-bj-img" :style="{'transition-duration': `1500ms`, 'transform': `rotate(${active * 34}deg)`}"></div>
        <div class="about-history-bj-img small" :style="{'transition-duration': `1500ms`, 'transform': `rotate(${active * 20}deg)`}"></div>
        <div class="inner"></div>
      </div>
      <div class="about-history-list flex_1">
        <div>
          <div class="about-history-list-title">{{ $t('about.history.list')[active].time }}</div>
          <div :class="{textj: language != 'en'}">
            <p v-for="(item, index) in $t('about.history.list')[active].des" :key="`qw_${index}`" :class="[language != 'en' ? 'flex' : '']"><span v-html="item.time" class="p-r-10"></span><span :class="[language == 'en' ? 'list-des' : 'flex_1']" v-html="item.content"></span></p>
          </div>
        </div>
      </div>
      <div class="about-history-timeline">
        <div class="about-history-longline"></div>
        <div class="flex box">
          <div class="speed-box">
            <div class="speed" :style="{width: `${ 100 / ($t('about.history.list').length - 1) * active}%`}"></div>
          </div>
          <div :class="['item', active == index ? 'active' : '', index != $t('about.history.list').length - 1 ? 'flex_1' : '']" v-for="(item, index) in $t('about.history.list')" :key="`11_${index}`" @click="setActive(index)">
            <div class="about-history-circle"></div>
            <p class="about-history-des">{{item.time}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { throttle, deepClone } from '@/utils'
export default {
  name: 'about',
  data () {
    return {
      active: 0,
      cultureStatus: false,
      realIndex: 0,
      timer: null,
      timerArr: [],
      aboutActive: 0,
      internationalActive: 0
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  created () {
    this.international = deepClone(this.$t('about.international.list'))
    this.about = deepClone(this.$t('about.about.list'))
  },
  mounted () {
    if (this.language === 'en') {
      // this.setSwiperM()
    } else {
      this.scrollFun = throttle(this.scrollFun, 200)
      window.addEventListener('scroll', this.scrollFun, true)
      this.setShowTxt('about', 'aboutActive')
    }
    this.closeTime()
    this.startLoop()
  },
  methods: {
    getNum (type, index) {
      let num = 0
      for (let i = 0; i < index; i++) {
        num += this[type][i].length
      }
      return num
    },
    scrollFun () {
      const scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      let realIndex = 0
      const screenH = document.documentElement.clientHeight
      const aboutH = this.$refs.about.clientHeight
      const cultureH = this.$refs.culture.clientHeight
      const internationalH = this.$refs.international.clientHeight
      if (scroll < aboutH - screenH) {
        realIndex = 0
      } else if (scroll >= aboutH - screenH + 100 && scroll < aboutH + cultureH - screenH) {
        realIndex = 1
      } else if (scroll >= aboutH + cultureH - screenH - 300 && scroll < aboutH + cultureH + internationalH - screenH) {
        realIndex = 2
      } else {
        realIndex = 3
      }
      this.closetimerArr()
      if (realIndex === 0) {
        this.setShowTxt('about', 'aboutActive')
      } else if (realIndex === 1) {
        this.cultureStatus = true
      } else if (realIndex === 2) {
        this.setShowTxt('international', 'internationalActive')
      }
    },
    setActive (index) {
      this.active = index
      this.startLoop()
    },
    startLoop () {
      this.closeTime()
      const duration = this.active > 3 ? 2000 : 3000
      this.timer = setInterval(() => {
        this.active > this.$t('about.history.year').length - 2 ? this.active = 0 : this.active++
        this.closeTime()
        this.startLoop()
      }, duration)
    },
    closeTime () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    setShowTxt (type, val) {
      this.setInterval(type, val)
    },
    setInterval (type, val) {
      // var wenlen = deepClone(this[val])
      const txtLen = this[type].map(item => item.length).reduce((a, b) => a + b)
      this.timerArr = setInterval(() => {
        // wenlen大于data.content的长度，停止计时器
        if (this[val] < txtLen) {
          if (type === 'international') {
            this[val] += 5
          } else {
            this[val] += 3
          }
        } else {
          this.closetimerArr()
        }
      }, 5)
    },
    closetimerArr () {
      if (this.timerArr) {
        clearInterval(this.timerArr)
        this.timerArr = null
      }
    }
  },
  beforeDestroy () { // 页面关闭时清除定时器
    this.closeTime()
    this.closetimerArr()
    window.removeEventListener('scroll', this.scrollFun, true)
  }
}
</script>
<style lang="less" scoped>
@keyframes LeftShow {
  0% {
    opacity: 0;
    left: -1em;
  }

  to {
    opacity: 1;
    left: 0;
  }
}
@-webkit-keyframes LeftShow {
  0% {
    opacity: 0;
    left: -1em;
  }

  to {
    opacity: 1;
    left: 0;
  }
}
.m .about {
  color: #ffffff;
  .about-swiper {
    height: 100vh;
    overflow: hidden;
  }
  .about-bj {
    position: relative;
    background: linear-gradient(60deg, #00A0E9 0%, #0046A3 100%);
    padding: 30px;
    padding-top: 90px;
    width: 100vw;
    color: rgba(255, 255, 255, 0.8);
    font-size: 26px;
    line-height: 38px;
    .about-bj-img {
      width: 80%;
      display: block;
    }
    .about-bj-list {
      padding-top: 80px;
      position: relative;
      z-index: 2;
      span {
        position: relative;
        visibility: hidden;
        text-align: center;
        opacity: 0;
        left: -1em;
        &.on {
          visibility: inherit;
          animation: LeftShow 0.25s ease-out both;
        }
      }
    }
  }
  .about-culture {
    background: linear-gradient(310deg, #116EB7 0%, #045798 100%);
    .about-culture-title {
      font-size: 40px;
      line-height: 56px;
      padding-bottom: 50px;
      text-align: center;
    }
    .about-culture-list {
      font-size: 26px;
      line-height: 34px;
      padding: 10PX 0;
      position: relative;
      left: 600px;
      opacity: 0;
      .about-culture-list-title {
        font-size: 30px;
        padding-top: 16PX;
        padding-bottom: 10PX;
      }
      .about-culture-list-des {
        padding-left: 52px;
      }
      &.show {
        left: 60px;
        opacity: 1;
      }
      &:nth-child(1) {
        .about-culture-list-title {
          img {
            width: 27px;
            height: 30px;
          }
        }
        transition: all .3s;
      }
      &:nth-child(2) {
        .about-culture-list-title {
          img {
            width: 32px;
            height: 34px;
          }
        }
        transition: all .6s;
      }
      &:nth-child(3) {
        .about-culture-list-title {
          img {
            width: 26px;
            height: 22px;
          }
        }
        transition: all .9s;
      }
      &:nth-child(4) {
        .about-culture-list-title {
          img {
            width: 26px;
            height: 26px;
          }
        }
        transition: all 1.2s;
      }
    }
  }
  .about-international {
    background: #014D89;
    .about-international-title {
      font-size: 40px;
    }
    .about-bj-list {
    }
    .about-international-img {
      // bottom: 5%;
      // bottom: 0;
      width: 90%;
    }
  }
  .about-history {
    padding-top: 100px;
    min-height: 100vh;
    background: #0067B2;
    position: relative;
    font-size: 26px;
    overflow: hidden;
    .about-history-bj {
      position: absolute;
      width: 100%;
      bottom: 0;
      opacity: 0.8;
      .about-history-bj-img {
        width: 180vw;
        height: 180vw;
        position: absolute;
        background-image: url('../../../assets/images/about/circle_big.png');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: 0 0;
        bottom: -100vw;
        opacity: 0.6;
        left: -40vw;
        &.small {
          background-image: url('../../../assets/images/about/circle_small.png');
          width: 160vw;
          height: 160vw;
          bottom: -100vw;
          left: -30vw;
        }
      }
      .inner {
        width: 120vw;
        position: absolute;
        height: 120vw;
        left: -10vw;
        bottom: -80vw;
        border: 1px solid #4e93c9;
        border-radius: 50%;
        opacity: 0.6;
      }
    }
    .about-history-title {
      font-size: 40px;
      line-height: 56px;
      // padding-top: 42px;
      text-align: center;
    }
    // .about-history-main {
    //   padding: 0 8vw 0 8vw;
    //   height: 100%;
    // }
    .about-history-list {
      line-height: 34px;
      width: 80%;
      margin: 0 auto;
      .about-history-list-title {
        font-size: 60px;
        font-weight: bold;
        text-align: center;
        line-height: 84px;
        padding: 30PX 0;
      }
      p {
        padding-bottom: 30px;
      }
    }
    .about-history-timeline {
      width: calc(100% - 16vw);
      padding-bottom: 50px;
      z-index: 2;
      .box {
        padding: 0 10% 54px;
        position: relative;
      }
      .about-history-longline {
        height: 4px;
        background: rgba(255, 255, 255, 0.2);
        &::before {
          content: '';
          height: 4px;
          width: calc(10% + 12px);
          background: #61c5ea;
          position: absolute;
        }
      }
      .item {
        position: relative;
        padding-top: 20px;
        color: rgba(255, 255, 255, 0.6);
        &:last-child {
          position: absolute;
          right: calc(10% + 15px)
        }
      }
      .speed-box {
        position: absolute;
        width: calc(100% - 20%);
        margin-left: 9px;
      }
      .speed {
        height: 4px;
        background: linear-gradient(90deg, #61c5ea 0%, #3a4ed3 100%);
        position: absolute;
        top: -4px;
        left: -7px;
        transition: width 1s;
      }
      .about-history-circle {
        position: absolute;
        width: 40px;
        height: 40px;
        top: -20px;
        left: -10px;
        &::before {
          content: '';
          position: absolute;
          display: block;
          width: 22px;
          height: 22px;
          top: 4px;
          left: 4px;
          background: #FFFFFF;
          border-radius: 50%;
          border: 3px solid #00A0E9;
          cursor: pointer;
          transition: all .2s;
        }
        // &:hover {
        //   &::before {
        //     width: 28px;
        //     height: 28px;
        //     top: 1px;
        //     left: 1px;
        //     border-color: #ffffff;
        //     background: #00A0E9;
        //     box-shadow: 0 0 5px 5px rgba(255, 255, 255, 0.2);
        //   }
        // }
      }
      .item.active {
        color: #ffffff;
        .about-history-circle {
          &::before {
            width: 28px;
            height: 28px;
            top: 1px;
            left: 1px;
            border-color: #ffffff;
            background: #00A0E9;
            // box-shadow: 0 0 5px 5px rgba(255, 255, 255, 0.2);
            animation: historyCircle 2s linear infinite;
          }
        }
      }
      .about-history-des {
        position: absolute;
        left: -0.5em;
      }
    }
  }
}
.m.en .about {
  .about-culture {
    .about-culture-list {
      left: 0px;
      top: 0;
      opacity: 1;
    }
  }
  .about-history {
    .about-history-timeline {
      padding-top: 30px;
    }
    .about-history-list {
      .list-des {
        color: rgba(255, 255, 255, 0.5);
      }
      p {
        padding-bottom: 10px;
      }
    }
  }
}
</style>
